import type { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { FilterEditor } from '@adornis/filter/client/filter-editor.js';
import type { FilterEditorOptions } from '@adornis/filter/filter-options.js';
import { useMemo } from '@adornis/functional-lit/stateful.js';
import { webcomponent } from '@adornis/functional-lit/webcomponent.js';
import type { TemplateResult } from 'lit';

export const BHFilterEditor = webcomponent<{
  noCollapse?: boolean;
  fullWidth?: boolean;
  options?: FilterEditorOptions<typeof AdornisEntity>;
  isFilterVisible?: boolean;
  additionalButtons?: () => TemplateResult;
  onFilterOpenAndClose?: (open: boolean) => void;
  onFilterApply?: (filter?: AdornisFilter) => void;
  onFilterReset?: () => void;
  onFilterChanged?: (filter: AdornisFilter) => void;
}>(
  'bh-filter-editor',
  ({ noCollapse, fullWidth, options, isFilterVisible, additionalButtons, onFilterOpenAndClose, onFilterApply, onFilterReset, onFilterChanged }) => {
    const filterOptions = useMemo(() => [options ? { ...options, searchSuggestions: false } : undefined], [options]);
    return FilterEditor({ noCollapse, fullWidth, options: filterOptions, isFilterVisible, additionalButtons, onFilterOpenAndClose, onFilterApply, onFilterReset, onFilterChanged });
  },
  { shadowRoot: true },
);
